export default __webpack_public_path__ + "static/media/student-red.763d91e3.svg";